const iDBCache = async (name, { lifetime, updateTimeWithRequest } = { lifetime: 10 }) => {
    const sTime = lifetime * 60 * 1000;
    const db = await new Promise(resolve => {
        const openRequest = window.indexedDB.open(name);
        openRequest.onerror = (e) => {
            resolve(undefined);
        };
        openRequest.onsuccess = () => {
            if (openRequest.result.objectStoreNames.contains(name)) {
                resolve(openRequest.result);
            }
            else {
                openRequest.result.close();
                window.indexedDB.deleteDatabase(name);
                resolve(undefined);
            }
        };
        openRequest.onupgradeneeded = (e) => {
            const db = openRequest.result;
            db.createObjectStore(name, { keyPath: 'key' });
            const trs = e.target.transaction;
            trs.oncomplete = () => {
                resolve(db);
            };
        };
    });
    if (db !== undefined && sTime > 0) {
        const clearOldValues = () => {
            const currentTime = Date.now();
            const store = db.transaction([name], 'readwrite').objectStore(name);
            const req = store.openCursor();
            req.onsuccess = () => {
                const cursor = req.result;
                if (cursor !== null) {
                    if ((currentTime - cursor.value.created) > sTime) {
                        cursor.delete();
                    }
                    cursor.continue();
                }
            };
        };
        clearOldValues();
        window.setInterval(() => {
            clearOldValues();
        }, 300000);
    }
    const getValue = async (key) => {
        return await new Promise(resolve => {
            if (db === undefined) {
                resolve(null);
                return;
            }
            const store = db.transaction([name], 'readwrite').objectStore(name);
            const req = store.get(key);
            req.onsuccess = () => {
                if (req.result !== undefined) {
                    if (updateTimeWithRequest === true) {
                        setValue(key, req.result.value);
                    }
                    resolve(req.result.value);
                }
                resolve(null);
            };
            req.onerror = () => {
                console.log(req.error);
                resolve(null);
            };
        });
    };
    const getAllEntries = async () => {
        return await new Promise(resolve => {
            if (db === undefined) {
                resolve(null);
                return;
            }
            const store = db.transaction([name], 'readwrite').objectStore(name);
            const req = store.getAll();
            req.onsuccess = () => {
                resolve(req.result.sort((a, b) => b.created - a.created));
            };
            req.onerror = () => {
                resolve(null);
            };
        });
    };
    const deleteValue = (key) => {
        if (db === undefined)
            return;
        const store = db.transaction([name], 'readwrite').objectStore(name);
        store.delete(key);
    };
    const setValue = (key, value) => {
        if (db === undefined)
            return;
        const store = db.transaction([name], 'readwrite').objectStore(name);
        store.put({
            key,
            value,
            created: Date.now()
        });
    };
    return {
        getValue,
        setValue,
        deleteValue,
        getAllEntries
    };
};
export default iDBCache;
